import { PropsOf } from 'types';
import connect from './connect';
import ErrorPage, { IProps } from './ErrorPage';

export default connect(ErrorPage);

export type ErrorPageProps = PropsOf<ReturnType<typeof connect>>;

export { IProps as IErrorPageProps };
